import React from 'react';
import { useTranslation } from 'react-i18next';

import withRouter from '../../hooks/with-router';
import PageContainer from '../../components/layout/page-container/PageContainer';
import AppEntityAvatar from '../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../components/designe/app-avatar/AppAvatar';
import { useGetMyDetails } from '../../services/redux/api/usersApi';
import { Typography } from '@mui/material';
import theme from '../../styles/theme';
import { useStyles } from './Home.styles';

function Home(props) {
  const { t } = useTranslation();
  const { data: user } = useGetMyDetails();
  const { classes } = useStyles(theme);

  return (
    <PageContainer title={t('common.myProfile')}>
      <div className={classes.userInfoWrapper}>
        <div className={classes.avatar}>
          <AppEntityAvatar entity={user} size={150} type={AvatarTypes.square} />
        </div>
        <div className={classes.info}>
          <Typography variant="text-lg">{`${user?.firstname || ''} ${user?.lastname || ''}`}</Typography>
          <Typography variant="text-md">{user?.description}</Typography>
        </div>
      </div>
    </PageContainer>
  );
}

export default withRouter(Home);
